import React, {Component} from "react";
import {Runtime, Inspector} from "@observablehq/runtime";
import notebook from "@namitmohale/monthly-utilization-report";

class ReportComponent extends Component {
    constructor(props){
        super(props);
        this.state = {
            // data: props.data,
            SCREEN_WIDTH: window.innerWidth
        }
    }

    animationRef = React.createRef();

    componentDidMount() {
        const runtime = new Runtime().module(notebook, name => {
          if (name === "chart") {
            return new Inspector(this.animationRef.current);
          }
        });
        runtime.redefine("height", (700));
        runtime.redefine("dotRadius", (12));
        runtime.redefine("labelSize", (28));
        runtime.redefine("titleSize", (40));
        runtime.redefine("titlePos", (25));
        runtime.redefine("dotX", (25));
        runtime.redefine("y1", (45));
        runtime.redefine("labelX", (40));
        runtime.redefine("y2", (90));
        runtime.redefine("xAxisTickSize", (24));
        runtime.redefine("yAxisTickSize", (22));
        runtime.redefine("yAxisLabelSize", (24));
        runtime.redefine("margin", {top: 80, right: 240, bottom: 40, left: 70})
    }

    render() {
        return (
            <div style={{padding: 20, height: '100%'}}>
                <div style={{ }} ref={this.animationRef}></div>
            </div>
        );
    }
}

export default ReportComponent;